/* esm.sh - date-fns@4.1.0/isValid */
import{isDate as r}from"./isDate.mjs";import{toDate as t}from"./toDate.mjs";function i(o){return!(!r(o)&&typeof o!="number"||isNaN(+t(o)))}var m=i;export{m as default,i as isValid};
//# sourceMappingURL=isValid.mjs.map